<div #dialogContainer class="dialog-content">
    <mat-dialog-content class="event-summary-dialog-content">
      <!-- Event Icon and Title -->
      <div class="event-header">
        @if(icon){
            <mat-icon [matTooltip]="data?.type?.name" class="event-icon">{{icon}}</mat-icon>
        }  
        @if(title){
            <h2 class="event-title">{{title}}</h2>
        }
        
        
      </div>
  
      <!-- Event Date and Time -->
      <div class="event-datetime">
        @if(data.allDay){
          <p>
            @if(allDayStart){
              Start Date:  {{allDayStart}} 
            }
            </p>
            <p>
              @if(allDayEnd){
                End Date:  {{allDayEnd}} 
              }
            
        </p>
        }@else{
          <p>
            @if(startDate){
                {{startDate | customDate}} 
            }
            
            – 
            @if(endDate){
                {{endDate | customDate}}
            }
            
        </p>
        }
        
      </div>
  
      <!-- Event Details List -->
      <div class="event-details">
        @if(data.meetingLink){
          <div class="event-detail">
            <mat-icon matTooltip="Meeting Link">event</mat-icon>
            <a [href]="data.meetingLink" target="_blank" rel="noopener noreferrer" class="meeting-link">
              Join Meeting
            </a>
          </div>
      }
        @if(leadName){
            <div class="event-detail" matTooltip="Lead Name" (click)="openLead()">
                <mat-icon >person</mat-icon>
                <span>{{leadName}}</span>
                <mat-icon>open_in_new</mat-icon>
              </div>
        }  

        @if(data?.notes){
          <div matTooltip="Notes">
            <mat-icon>note</mat-icon>
            <app-item [note]="data.notes" [hideActions]="true"></app-item>
          </div>
        }

        @if(data.assignedTo){
          <div class="event-detail" matTooltip="Activity Owner">
            <mat-icon>person_outline</mat-icon>
            <span>{{data.assignedTo.name }}  {{data.assignedTo.lastName}}</span>
          </div>
        }

        
        @if(data?.campus?.id){
          <div class="event-detail" matTooltip="Campus Name">
            <mat-icon>business</mat-icon>
            <span>{{data.campus.name}}</span>
          </div>
        }
        
        
        <!-- 
        <div class="event-detail">
          <mat-icon>person_outline</mat-icon>
          <span>Enver Krivaça Candidate</span>
        </div>
        <div class="event-detail">
          <mat-icon>business</mat-icon>
          <span>Kosovo Customs</span>
        </div> -->
      </div>
    </mat-dialog-content>
  
    <mat-dialog-actions class="actions-main" >
      <button mat-icon-button color="warn" matTooltip="Delete Activity" (click)="deleteActivity()">
        <mat-icon>delete</mat-icon>
      </button>
      <!-- <button mat-stroked-button color="primary" (click)="markCompleted()">
          @if(completed){
            <mat-icon>check_circle</mat-icon>
          }
        
        {{!completed ? 'Mark completed': 'Mark uncompleted'}}
      </button> -->
      <div class="event-actions">
        <mat-checkbox [checked]="completed" (change)="onMarkCompletedChange($event)">
          @if(completed){
            Marked
          }
          @else{
            Mark
          }
           as Done
        </mat-checkbox>
        <button mat-raised-button color="accent" (click)="editActivity()">Edit</button>
      </div>
      
    </mat-dialog-actions>
  </div>
  